module.exports = __webpack_public_path__ + "6bf9de20b10c4fa7b7d15c73ee62f138.svg";